<template>
  <div class="qr-modal-wrapper">
    <div
      :class="[isModalOpen ? 'd-flex' : 'd-none']"
      class="size-modal image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center"
    >
      <div class="modal-inner d-flex align-items-center justify-content-center h-100 w-100">
        <div
          class="bm-modal-content qr-dialog"
          :class="{ 'is-vcard': activeTab === 'vcard' }"
          role="dialog"
          aria-modal="true"
          aria-label="Add QR Code"
        >
          <div class="qr-header">
            <h2 class="modal-heading">Add QR Code</h2>
            <button
              type="button"
              class="qr-close"
              aria-label="Close"
              title="Close"
              @click="handleModalClose"
            >
              <icon name="close-icon"/>
            </button>
          </div>

          <div
            class="tabs"
            role="tablist">
            <button
              type="button"
              role="tab"
              class="tab-btn"
              :class="{ active: activeTab === 'url' }"
              :aria-selected="activeTab === 'url' ? 'true' : 'false'"
              @click="setActiveTab('url')"
            >
              URL
            </button>
            <button
              type="button"
              role="tab"
              class="tab-btn"
              :class="{ active: activeTab === 'vcard' }"
              :aria-selected="activeTab === 'vcard' ? 'true' : 'false'"
              @click="setActiveTab('vcard')"
            >
              vCard
            </button>
          </div>

          <div class="bm-modal-body main-tabs-content">
            <div
              v-if="activeTab === 'url'"
              class="qr-field">
              <label
                class="field-label"
                for="qr-url-input">Add a URL</label>
              <div
                class="qr-control"
                :class="{ 'is-invalid': url.length > 0 && !isValidURL }">
                <input
                  id="qr-url-input"
                  v-model.trim="url"
                  type="text"
                  placeholder="www.example.com"
                  @click.stop
                  autocomplete="off"
                >
              </div>
              <div
                v-if="url.length > 0 && isValidURL"
                class="qr-hint is-valid">
                <icon name="check-circle"/>
                <span>URL is valid</span>
              </div>
              <div
                v-if="url.length > 0 && !isValidURL"
                class="qr-hint is-invalid">
                <icon name="alert-circle"/>
                <span>URL is not valid</span>
              </div>
            </div>

            <div
              v-if="activeTab === 'vcard'"
              class="vcard-panel">
              <div class="autofill-notice">
                <icon name="sparkle"/>
                <span>Filled in from your profile. Edit anything before inserting.</span>
              </div>

              <div class="vcard-grid">
                <div class="full-width qr-field">
                  <label
                    class="field-label"
                    for="qr-full-name">Full Name<span class="qr-required"> *</span></label>
                  <div
                    class="qr-control"
                    :class="{ 'is-invalid': showError && !(vcard.fullName || '').trim() }">
                    <input
                      id="qr-full-name"
                      v-model="vcard.fullName"
                      type="text"
                      autocomplete="off"
                      placeholder="Jane Smith">
                  </div>
                  <div
                    v-if="showError && !(vcard.fullName || '').trim()"
                    class="qr-hint is-invalid">
                    <icon name="alert-circle"/>
                    <span>Name is required</span>
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-org">Organization</label>
                  <div class="qr-control">
                    <input
                      id="qr-org"
                      autocomplete="off"
                      v-model="vcard.org"
                      type="text"
                      placeholder="Acme Corp">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-title">Title</label>
                  <div class="qr-control">
                    <input
                      id="qr-title"
                      autocomplete="off"
                      v-model="vcard.title"
                      type="text"
                      placeholder="Product Manager">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-phone">Phone</label>
                  <div class="qr-control">
                    <input
                      id="qr-phone"
                      autocomplete="off"
                      v-model="vcard.phone"
                      class="qr-mono"
                      type="tel"
                      placeholder="+1 (555) 000-0000">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-mobile">Mobile</label>
                  <div class="qr-control">
                    <input
                      id="qr-mobile"
                      v-model="vcard.mobile"
                      autocomplete="off"
                      class="qr-mono"
                      type="tel"
                      placeholder="+1 (555) 000-0001">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-email">Email</label>
                  <div class="qr-control">
                    <input
                      id="qr-email"
                      autocomplete="off"
                      v-model="vcard.email"
                      type="email"
                      placeholder="jane@acme.com">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-website">Website</label>
                  <div class="qr-control">
                    <input
                      id="qr-website"
                      autocomplete="off"
                      v-model="vcard.website"
                      type="url"
                      placeholder="www.acme.com">
                  </div>
                </div>

                <div class="full-width qr-field">
                  <label
                    class="field-label"
                    for="qr-address">Address</label>
                  <div class="qr-control">
                    <input
                      id="qr-address"
                      autocomplete="off"
                      v-model="vcard.address"
                      type="text"
                      placeholder="123 Main St">
                  </div>
                </div>

                <div class="qr-field">
                  <label
                    class="field-label"
                    for="qr-city">City</label>
                  <div class="qr-control">
                    <input
                      id="qr-city"
                      v-model="vcard.city"
                      autocomplete="off"
                      type="text"
                      placeholder="New York">
                  </div>
                </div>

                <div class="state-zip">
                  <div class="qr-field">
                    <label
                      class="field-label"
                      for="qr-state">State</label>
                    <div class="qr-control">
                      <input
                        id="qr-state"
                        v-model="vcard.state"
                        autocomplete="off"
                        type="text"
                        placeholder="NY">
                    </div>
                  </div>
                  <div class="qr-field">
                    <label
                      class="field-label"
                      for="qr-zip">Zip</label>
                    <div class="qr-control">
                      <input
                        id="qr-zip"
                        v-model="vcard.zip"
                        class="qr-mono"
                        autocomplete="off"
                        type="text"
                        placeholder="10001">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="showPreview && generatedSVG"
              ref="qrPreview"
              class="preview-div">
              <div
                class="preview-card"
                v-html="generatedSVG"/>
              <span class="preview-label">Preview</span>
            </div>
          </div>

          <div class="bm-modal-footer">
            <button
              type="button"
              class="lf-btn red-border-btn action-btn bg-white"
              @click="handleModalClose"
            >
              Cancel
            </button>
            <span class="footer-spacer"/>
            <button
              type="button"
              :disabled="activeTab === 'url' && !isValidURL"
              class="lf-btn preview-action-btn action-btn bg-white"
              @click.stop="addQRCode"
            >
              Preview
            </button>
            <button
              type="button"
              :disabled="activeTab === 'url' && !isValidURL"
              class="bm-primary-btn action-btn"
              @click.stop="insertQRCode"
            >
              Insert
            </button>
          </div>
        </div>
      </div>

      <div
        class="backdrop position-fixed h-100 w-100"
        @click="handleModalClose"
      />
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode-svg';
import EventBus from '@/EventBus';
import validator from 'validator';

export default {
  data() {
    return {
      url:          '',
      showError:    false,
      generatedSVG: '',
      showPreview:  false,
      activeTab:    'url',
      vcard:        {
        fullName: '',
        org:      '',
        title:    '',
        phone:    '',
        mobile:   '',
        email:    '',
        website:  '',
        address:  '',
        city:     '',
        state:    '',
        zip:      '',
      },
    };
  },
  computed: {
    isModalOpen() {
      return this.$store.getters.getDisplayQRCodeModal;
    },
    isValidURL() {
      return validator.isURL(this.url);
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  watch: {
    url() {
      this.hidePreview();
    },
    vcard: {
      deep: true,
      handler() {
        this.hidePreview();
      },
    },
    userInfo: {
      immediate: true,
      handler(user) {
        if (!user) { return; }

        this.vcard = {
          fullName: user.fullname || '',
          org:      user.bankname || '',
          title:    user.title || '',
          phone:    user.phone || '',
          mobile:   user.phone || '',
          email:    user.email || '',
          website:  '',
          address:  user.address || '',
          city:     user.city || '',
          state:    user.state || '',
          zip:      user.zip || '',
        };
      },
    },
  },
  methods: {
    hidePreview() {
      if (!this.showPreview && !this.generatedSVG) { return; }
      this.generatedSVG = '';
      this.showPreview  = false;
    },
    setActiveTab(tab) {
      this.hidePreview();
      this.showError = false;
      this.activeTab = tab;
    },
    generateVCardString() {
      const v = this.vcard;

      const lines     = [
        'BEGIN:VCARD',
        'VERSION:3.0',
      ];
      const nameParts = (v.fullName || '').trim().split(' ');

      const firstName = nameParts.shift() || '';
      const lastName  = nameParts.join(' ') || '';

      lines.push(`N:${lastName};${firstName};;;`);
      lines.push(`FN:${v.fullName}`);

      const fields = [
        ['ORG', v.org],
        ['TITLE', v.title],
        ['TEL', v.phone],
        ['TEL;TYPE=CELL', v.mobile],
        ['EMAIL', v.email],
        ['URL', v.website],
      ];

      fields.forEach(([key, value]) => {
        if (value && value.trim()) {
          lines.push(`${key}:${value}`);
        }
      });

      const addressParts = [
        v.address,
        v.city,
        v.state,
        v.zip,
      ];

      if (addressParts.some(part => part && part.trim())) {
        lines.push(
          `ADR:;;${addressParts.map(part => part || '').join(';')}`,
        );
      }

      lines.push('END:VCARD');

      return lines.join('\n');
    },
    handleModalClose() {
      this.hidePreview();
      this.showError = false;
      this.$store.commit('setDisplayQRCodeModal', false);
    },


    addQRCode() {
      let content = '';

      if (this.activeTab === 'url') {
        if (!this.isValidURL) { return; }
        content = this.url;
      } else {
        this.showError = true;
        if (!this.vcard.fullName.trim()) {
          return;
        }
        content = this.generateVCardString();
      }

      const svg = new QRCode({
        content,
        width:      256,
        height:     256,
        color:      '#000',
        background: 'transparent',
      }).svg({ container: 'svg-viewbox' });

      this.generatedSVG = svg;
      this.showPreview  = true;
      this.$nextTick(() => {
        const preview = this.$refs.qrPreview;
        if (preview && preview.scrollIntoView) {
          preview.scrollIntoView({ block: 'nearest' });
        }
      });
    },
    insertQRCode() {
      let content = '';

      if (this.activeTab === 'url') {
        if (!this.isValidURL) { return; }

        content = this.url;
      } else {
        this.showError = true;

        if (!this.vcard.fullName || !this.vcard.fullName.trim()) {
          return;
        }

        content = this.generateVCardString();
      }

      let svg = new QRCode({
        content,
        padding:        0,
        width:          256,
        height:         256,
        color:          '#000000',
        background:     null,
        join:           true,
        xmlDeclaration: false,
      }).svg();

      const div     = document.createElement('div');
      div.innerHTML = svg.trim();

      svg = div.firstChild;

      svg.removeChild(svg.firstElementChild);
      svg.style.transformOrigin = 'left top';

      svg = svg.outerHTML;

      this.generatedSVG = svg;

      EventBus.$emit('AddSvgShape', {
        content: svg,
        name:    'QR-Code',
        color:   'rgb(0,0,0)',
        width:   256,
        height:  256,
      });

      this.handleModalClose();
    },
  },
};

</script>
<style lang="scss">
.qr-modal-wrapper {
  .modal-inner {
    position: relative;
    z-index: 1;
  }

  .image-modal-wrapper .bm-modal-content.qr-dialog {
    width: 500px !important;
    min-width: 0 !important;
    max-width: calc(100vw - 32px) !important;
    height: auto !important;
    max-height: calc(100vh - 48px) !important;
    padding: 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.28);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    z-index: 2;
    font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
    color: #14161B;
    -webkit-font-smoothing: antialiased;

    &.is-vcard {
      width: 520px !important;
    }
  }

  .qr-header {
    display: flex;
    align-items: flex-start;
    flex-shrink: 0;
    gap: 12px;
    padding: 20px 20px 14px 24px;
  }

  .qr-dialog .modal-heading {
    flex: 1 1 auto;
    min-width: 0;
    margin: 0;
    font-family: inherit;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
    color: #14161B;
    text-align: left;
  }

  .qr-close {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    padding: 0;
    cursor: pointer;
    background: transparent;
    color: #3D4350;
  }

  .qr-close:hover {
    background: #F3F4F6;
  }

  .tabs {
    display: flex;
    flex-shrink: 0;
    gap: 24px;
    margin: 0;
    padding: 0 24px;
    border-bottom: 1px solid #E7E9ED;
  }

  .tab-btn {
    flex: 0 0 auto;
    height: 42px;
    display: flex;
    align-items: center;
    padding: 0 2px;
    border: 0;
    background: transparent;
    box-shadow: inset 0 0 0 #1570EF;
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 500;
    color: #5E6573;
    cursor: pointer;
  }

  .tab-btn.active {
    font-weight: 650;
    color: #14161B;
    box-shadow: inset 0 -2px 0 #1570EF;
  }

  .tab-btn:hover:not(.active) {
    color: #14161B;
  }

  .bm-modal-body.main-tabs-content {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 16px;
    min-height: 0;
    max-height: calc(100vh - 224px);
    overflow-y: auto;
    padding: 20px 24px;
  }

  .qr-field {
    min-width: 0;
  }

  .field-label {
    display: block;
    margin: 0 0 6px;
    font-family: inherit;
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.3;
    color: #3D4350;
  }

  .qr-required {
    color: #D92D20;
  }

  .qr-control {
    height: 38px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    background: #fff;
    border-radius: 9px;
    box-sizing: border-box;
    box-shadow: inset 0 0 0 1px #E7E9ED;
  }

  .qr-control.is-invalid {
    box-shadow: inset 0 0 0 1.5px #D92D20;
  }

  .qr-control:focus-within {
    box-shadow: inset 0 0 0 1.5px #1570EF, 0 0 0 3px rgba(21, 112, 239, 0.15);
  }

  .qr-control input {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    background: transparent;
    padding: 0;
    margin: 0;
    font-family: inherit;
    font-size: 13.5px;
    font-weight: 400;
    color: #14161B;
    box-shadow: none;
  }

  .qr-control input.qr-mono {
    font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  }

  .qr-control input::placeholder {
    color: #8B919C;
  }

  .qr-hint {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.3;
  }

  .qr-hint.is-valid {
    color: #127A43;
  }

  .qr-hint.is-invalid {
    color: #D92D20;
  }

  .autofill-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border: 0;
    border-radius: 8px;
    background: #EAF2FE;
    font-size: 12.5px;
    line-height: 1.4;
    color: #0B57C2;
    margin-bottom: 16px;
  }

  .autofill-notice .icon {
    min-width: 0;
    min-height: 0;
    flex-shrink: 0;
  }

  .autofill-notice .icon svg {
    width: 14px;
    height: 14px;
  }

  .vcard-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .vcard-grid .full-width {
    grid-column: 1 / -1;
  }

  .state-zip {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    min-width: 0;
  }

  .preview-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 18px;
    border-radius: 12px;
    background: #F3F4F6;
  }

  .preview-card {
    padding: 10px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #E7E9ED;
    line-height: 0;
  }

  .preview-card svg {
    display: block;
    width: 180px;
    height: 180px;
    overflow: visible;
  }

  .preview-label {
    font-size: 12px;
    line-height: 1.3;
    color: #5E6573;
  }

  .qr-close .icon,
  .qr-hint .icon {
    min-width: 0;
    min-height: 0;
  }

  .qr-close .icon svg {
    width: 16px;
    height: 16px;
  }

  .qr-hint .icon svg {
    width: 13px;
    height: 13px;
  }

  .bm-modal-footer {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    max-width: 100% !important;
    width: 100%;
    margin: 0;
    padding: 14px 24px;
    border-top: 1px solid #E7E9ED;
    background: #FBFBFC;
  }

  .footer-spacer {
    flex: 1 1 auto;
  }

  .bm-modal-footer .action-btn {
    height: 38px;
    min-height: 38px;
    min-width: 72px;
    padding: 0 14px;
    border: 0 !important;
    border-radius: 9px;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }

  .bm-modal-footer .red-border-btn {
    background: #fff !important;
    color: #D92D20 !important;
    box-shadow: inset 0 0 0 1px #FBC9C4;
  }

  .bm-modal-footer .red-border-btn:hover {
    background: #FEF3F2 !important;
    color: #D92D20 !important;
  }

  .bm-modal-footer .preview-action-btn {
    background: #fff !important;
    color: #14161B !important;
    box-shadow: inset 0 0 0 1px #D5D9E0;
  }

  .bm-modal-footer .preview-action-btn:hover:not(:disabled) {
    background: #F3F4F6 !important;
  }

  .bm-modal-footer .bm-primary-btn {
    background: #1570EF !important;
    color: #fff !important;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
  }

  .bm-modal-footer .bm-primary-btn:hover:not(:disabled) {
    background: #0B57C2 !important;
  }

  .bm-modal-footer .action-btn:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  @media screen and (max-width: 560px) {
    .vcard-grid {
      grid-template-columns: minmax(0, 1fr);
    }

    .vcard-grid .full-width {
      grid-column: auto;
    }
  }
}
</style>
